// extracted by extract-css-chunks-webpack-plugin
module.exports = {"red":"#d73c4b","blue":"#0f1e3c","bluetint":"#27344f","eggShell":"#f5f5f6","lightgray":"#dddfe1","black":"#000","darkgray":"#b4b9be","white":"#fff"};